import { MetasearchFeedStatus, FEED_STATUS_COLORS, FEED_STATUS_LABELS } from "../types";

const BOOLEAN_STYLES = {
  true: "bg-green-100 text-green-800 border-green-300",
  false: "bg-gray-100 text-gray-800 border-gray-300",
} as const;

export function Badge({
  children,
  className,
}: {
  children: React.ReactNode;
  className: string;
}) {
  return (
    <span
      className={`inline-flex items-center justify-center px-2 py-1 rounded text-xs font-medium border ${className}`}
    >
      {children}
    </span>
  );
}

export function BooleanBadge({
  value,
  trueLabel = "Yes",
  falseLabel = "No",
}: {
  value: boolean;
  trueLabel?: string;
  falseLabel?: string;
}) {
  return (
    <Badge className={value ? BOOLEAN_STYLES.true : BOOLEAN_STYLES.false}>
      {value ? trueLabel : falseLabel}
    </Badge>
  );
}

export function StatusBadge({ status }: { status: MetasearchFeedStatus }) {
  return (
    <Badge className={FEED_STATUS_COLORS[status]}>
      {FEED_STATUS_LABELS[status]}
    </Badge>
  );
}
